import React,{useState, useEffect} from 'react';
import './App.css';
import {FormControl , Select, MenuItem, CardContent, Card} from '@material-ui/core';
import InfoBox from './InfoBox';
import Map from "./Map";
import Table from "./Table";
import Graph from "./Graph"; 
import "leaflet/dist/leaflet.css";

function App() {

  const [countries, setcountries] = useState([]);
  const [country, setcountry] = useState('worldwide');
  const [countryInfo, setcountryInfo] = useState([]);
  const [mapcenter, setmapcenter] = 
  useState({ lat: 34.80746, lng: -40.4796 });
  const [mapzoom, setmapzoom] = useState(3);
  const [casesType, setcasesType] = useState("cases")

  useEffect(() => {
    const getCountries = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
      .then(response => response.json())
      .then((data) => {
        setcountries(data); 
      })
    }
    getCountries();
  }, [])

  useEffect(() => {
    fetch("https://disease.sh/v3/covid-19/all")
    .then(response=>response.json())
    .then(data=>
      setcountryInfo(data))
  }, [])

  const onchange = async (event) => {
    const country = event.target.value;
    setcountry(country);
    // const url = 
    // country === "worldwide" ? "https://disease.sh/v3/covid-19/all" : 
    // `https://disease.sh/v3/covid-19/countries/${country}`;
    // await fetch(url)
    // .then(response=>response.json())
    // .then(data=>{
    //   setcountryInfo(data);
    //   setmapcenter([data.countryInfo.lat , data.countryInfo.long]);
    //   setmapzoom(4)
    //   })

      if(country === "worldwide"){
        await fetch ("https://disease.sh/v3/covid-19/all")
        .then(response=>response.json())
        .then(data=>{
          setcountryInfo(data);
          setmapcenter([0 , 0])
          setmapzoom(4)
        })
      }else{
        await fetch(`https://disease.sh/v3/covid-19/countries/${country}`)
        .then(response=>response.json())
        .then(data=>{
          setcountryInfo(data);
          setmapcenter([data.countryInfo.lat , data.countryInfo.long]);
          setmapzoom(4)
          })
      }
  }

  const sorted = [...countries] 
  const sortdata = sorted.sort((a,b) => a.cases > b.cases ? -1 : 1)

  return (
    <div className="app">
      <div className="left">
        <div className="header">
          <h1 className='title'>Covid-19 Tracker</h1>
          <FormControl className="select">
            <Select variant="outlined" value={country} onChange={onchange}>
              <MenuItem value="worldwide">WorldWide</MenuItem>
              {
                countries.map((country)=>(
                  <MenuItem value={country.countryInfo.iso2}>{country.country}</MenuItem>
                  ))
              }
            </Select>
          </FormControl>
        </div>
        <div className="infoBox">
          <InfoBox isRed active= {casesType === "cases"}
          onClick= {e => setcasesType('cases')}
          total={countryInfo.cases} cases={countryInfo.todayCases} title="CoronaVirus Cases"/>
          <InfoBox active= {casesType === "recovered"}
          onClick= {e => setcasesType('recovered')}
           total={countryInfo.recovered} cases={countryInfo.todayRecovered} title="Recovered"/>
          <InfoBox isRed active= {casesType === "deaths"}
          onClick= {e => setcasesType('deaths')}
          total={countryInfo.deaths} cases={countryInfo.todayDeaths} title="Deaths"/>
        </div>
        <Map casesType={casesType} countries={countries} center={mapcenter} zoom={mapzoom}/>
      </div>
      <div className="right">
        <Card>
          <CardContent>
            <h3>Live Cases by Countries</h3>
            <Table countries={sortdata}/> 
            <h3 className="graph_title">Worldwide {casesType} </h3>
            <Graph className="graph" casesType={casesType}/>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default App;
